export default function PHP_While_Loop() {
  return (
    <div>
      <h1>PHP_While_Loop</h1>
    </div>
  );
}
